import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text, XStack, YStack } from 'tamagui';
import { tokens } from 'tamagui-config';

import { weatherIconMap } from './WeatherIconMap';
import { WidgetCard } from '../../../components/common';
import { WeatherIconName } from '../../../types/Weather';

export type WeatherHighLowCardProps = {
  temperature: string;
  condition: string;
  low: { value: string; time?: string };
  high: { value: string; time?: string };
  iconName: WeatherIconName;
};

export const WeatherHighLowCard = ({
  temperature,
  condition,
  low,
  high,
  iconName,
}: WeatherHighLowCardProps) => {
  const { t } = useTranslation();
  const mainIcon = weatherIconMap[iconName];

  return (
    <WidgetCard
      title={t('weather.todayHighLow')}
      isDraggable={false}
      dragHandleProps={null}
      error={false}
      gap="$3.5">
      <YStack gap="$3.5" justifyContent="space-between" flex={1}>
        <XStack width="100%" justifyContent="space-between" alignItems="center">
          <YStack>
            <Text fontSize="$12" fontWeight="900">
              {temperature}
            </Text>
            <Text fontSize="$9.5">{condition}</Text>
          </YStack>

          {mainIcon && (
            <YStack justifyContent="center">{mainIcon(tokens.color.textLight, 119, true)}</YStack>
          )}
        </XStack>

        <YStack
          backgroundColor="$transparentBorder"
          padding="$5"
          borderRadius="$6"
          gap="$4"
          height="183px"
          justifyContent="center">
          <XStack justifyContent="space-between" alignItems="center" width="100%">
            <Text fontSize="$9.5">{t('weather.lowest')}</Text>
            <Text fontWeight="700" fontSize="$9.5">
              {low.value}
            </Text>
          </XStack>
          <XStack justifyContent="space-between">
            <Text fontSize="$9.5">{t('weather.highest')}</Text>
            <Text fontWeight="700" fontSize="$9.5">
              {high.value}
            </Text>
          </XStack>
        </YStack>
      </YStack>
    </WidgetCard>
  );
};
